import { render } from "./SpaceFormPageFive.vue?vue&type=template&id=513c7b89"
import script from "./SpaceFormPageFive.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageFive.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "513c7b89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('513c7b89', script)) {
    api.reload('513c7b89', script)
  }
  
  module.hot.accept("./SpaceFormPageFive.vue?vue&type=template&id=513c7b89", () => {
    api.rerender('513c7b89', render)
  })

}

script.__file = "src/components/dashboard/space-form-pages/SpaceFormPageFive.vue"

export default script